import { jsx } from "react/jsx-runtime";
const CarouselDotButton = ({ dotButtonClasses, dotClasses, ...restProps })=>/*#__PURE__*/ jsx("button", {
        "data-testid": "carousel-dot-button",
        className: dotButtonClasses,
        type: "button",
        ...restProps,
        children: /*#__PURE__*/ jsx("div", {
            className: dotClasses
        })
    });
export { CarouselDotButton };
